<template>
    <Breadcrumb :items="breadcrumbs" />
    <Loading v-if="loading" />

    <!-- Barcode Scanner panel -->
    <div class="card mb-3 border-primary" v-if="!loading">
        <div class="card-body py-3">
            <h6 class="card-title mb-3">
                <i class="pi pi-barcode me-1"></i> تسجيل الحضور بالباركود
            </h6>
            <BarcodeScanner mode="attendance" @scanned="handleAttendanceQR" />
        </div>
    </div>

    <div class="row" v-if="!loading">
        <div class="col-lg-6 col-md-12 col-12">
            <div class="form-group">
                <label for="search">ابحث</label>
                <input type="search" id="search" class="form-control" placeholder="ابحث" v-model="word"
                    @keyup="debounceFetchAttendance">
            </div>
        </div>
        <div class="col-lg-2 col-md-6 col-12">
            <div class="form-group d-flex flex-column">
                <label for="month">الشهور</label>
                <Dropdown v-model="selectedMonth" :options="months" showClear optionLabel="name" placeholder="الشهور"
                    @change="fetchAttendance" />
            </div>
        </div>
        <div class="col-lg-2 col-md-6 col-12">
            <div class="form-group d-flex flex-column">
                <label for="gender">الجنس</label>
                <Dropdown v-model="gender" :options="gender_list" showClear optionLabel="title" placeholder="الجنس"
                    @change="fetchAttendance" />
            </div>
        </div>
        <div class="col-lg-2 col-md-3 col-12">
            <div class="d-flex">
                <div class="form-group d-flex flex-column mx-1">
                    <label for="" class="non_opacity">طباعة</label>
                    <button class="btn btn-success px-3" @click="exportToExcel">
                        <i class="pi pi-file-excel"></i>
                    </button>
                </div>
                <div class="form-group d-flex flex-column mx-1">
                    <label for="" class="non_opacity">طباعة</label>
                    <button class="btn btn-danger px-3" v-print="'#reservationTable'">
                        <i class="pi pi-file-pdf"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="table-responsive attendance-table" v-if="!loading">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th>الاسم</th>
                    <th v-for="day in days" :key="day">
                        <p class="mb-0">{{ getDayName(day) }}</p>
                        <p class="mb-0">{{ formatDayMonth(day) }}</p>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="student in students" :key="student.user_id">
                    <td>{{ student.name }} <span v-if="student.attendanceDates.length" class="text-danger fw-bold">({{
                        student.attendanceDates.length }})</span></td>
                    <td v-for="day in days" :key="day" class="text-center"
                        :class="student.attendanceDates.includes(day) ? 'bg-danger text-white' : ''">
                        <template v-if="student.attendanceDates.includes(day)">
                          <input type="checkbox" id="attendance_check" :checked="false" hidden
                                 @change="toggleAttendance(student.user_id, day, $event.target.checked)" />
                          <label for="attendance_check">
                            <i class="pi pi-times"></i>
                          </label>
                        </template>
                        <template v-else>
                            <input type="checkbox" :checked="false"
                                @change="toggleAttendance(student.user_id, day, $event.target.checked)" />
                        </template>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>


    <Dialog v-model:visible="visible" modal header="رساله الغياب" :style="{ width: '50vw' }"
        :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
        <Textarea v-model="attendance_message" name="attendance_message" style="display: block; width: 100%;" id="attendance_message" cols="30" rows="5" />
        <div class="text-end mt-1" :class="attendance_message.length > 70 ? 'text-danger' : 'text-success'">
          {{ attendance_message.length }} حرف
          <span class="ms-2">عدد الرسائل: {{ smsCount }}</span>
        </div>
        <button type="button" class="PrimaryButton mt-3" @click="SendAttendanceMessage">إرسال</button>
    </Dialog>
</template>

<script>
import axios from "axios";
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import Dialog from 'primevue/dialog';
import Swal from 'sweetalert2';
import Textarea from 'primevue/textarea';
import Breadcrumb from '@/components/global/breadcrumb.vue';
import Loading from '@/components/global/loading.vue';
import BarcodeScanner from '@/components/global/BarcodeScanner.vue';
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
    data() {
        return {
            students: [],
            days: [],
            selectedMonth: {
                id: new Date().getMonth() + 1, // الشهر الحالي (1-12)
                name: new Date().toLocaleString('default', { month: 'long' }) // اسم الشهر الحالي
            },
            months: [
                {
                    id: 1,
                    name: "يناير",
                },
                {
                    id: 2,
                    name: "فبراير",
                },
                {
                    id: 3,
                    name: "مارس",
                },
                {
                    id: 4,
                    name: "أبريل",
                },
                {
                    id: 5,
                    name: "مايو",
                },
                {
                    id: 6,
                    name: "يونيو",
                },
                {
                    id: 7,
                    name: "يوليو",
                },
                {
                    id: 8,
                    name: "أغسطس",
                },
                {
                    id: 9,
                    name: "سبتمبر",
                },
                {
                    id: 10,
                    name: "أكتوبر",
                },
                {
                    id: 11,
                    name: "نوفمبر",
                },
                {
                    id: 12,
                    name: "ديسمبر",
                }
            ],
            gender_list: [
                {
                    id: 1,
                    title: "ولد",
                },
                {
                    id: 2,
                    title: "بنت",
                },
            ],
            word: '',
            gender: null,
            searchTimeout: null,
            visible: false,
            attendance_id: null,
            attendance_message: '',
            parent_phone: null,
            loading: false,
        };
    },
    components: {
        Button,
        Dropdown,
        Dialog,
        Textarea,
        Breadcrumb,
        Loading,
        BarcodeScanner,
    },
    computed: {
      smsCount() {
        return Math.ceil(this.attendance_message.length / 70) || 1;
      },
      gradeStore() { return useGradeStore(); },
      gradeSlug() {
        return this.$route.params.gradeSlug;
      },
      grade() {
        const slug = this.gradeSlug;
        if (!slug) return null;
        return this.gradeStore.activeGrades.find(g => g.slug === slug)
            || this.gradeStore.allGrades.find(g => g.slug === slug)
            || null;
      },
      gradeId() {
        return this.grade?.id ?? null;
      },
      breadcrumbs() {
        const gradeName = this.grade?.name ?? this.gradeSlug ?? '';
        const gradePath = this.grade
            ? `/grades/${this.grade.slug}/students`
            : '/';
        return [
          { name: 'الرئيسية', path: '/' },
          { name: gradeName, path: gradePath },
          { name: 'الغياب', path: this.$route.fullPath },
        ];
      },
    },
    methods: {
        debounceFetchAttendance() {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.fetchAttendance();
            }, 1500); // يمكنك تغيير المدة حسب الحاجة
        },
        getDayName(dateStr) {
            const days = ['لأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];
            const d = new Date(dateStr);
            return days[d.getDay()];
        },
        formatDayMonth(dateStr) {
            // dateStr: "2025-06-27"
            const [, mm, dd] = dateStr.split('-');
            return `${dd}-${mm}`;
        },
        getEducationLevelLabel(level) {
          const levels = {
            1: "الاول الاعدادي",
            2: "الثاني الاعدادي",
            3: "الثالث الاعدادي",
            4: "الاول الثانوي",
            5: "الثاني الثانوي",
            6: "الثالث الثانوي",
          };
          return levels[level] || `${level}`;
        },

        getEducationLevelPath(level) {
          if (level == 3) return '/reservation';
          if (level == 4) return '/one_secondary';
          if (level == 5) return '/two_secondary';
          if (level == 6) return '/three_secondary';
          return `/absence/${level}`;
        },
        getDaysOfMonth(year, month) {
            const days = [];
            const date = new Date(year, month, 1);
            while (date.getMonth() === month) {
                const yyyy = date.getFullYear();
                const mm = String(date.getMonth() + 1).padStart(2, '0');
                const dd = String(date.getDate()).padStart(2, '0');
                days.push(`${yyyy}-${mm}-${dd}`);
                date.setDate(date.getDate() + 1);
            }
            return days;
        },
        async fetchAttendance() {
            const formData = new FormData();
            if (this.gradeId) {
                formData.append('academic_year_id', this.gradeId);
            }
            formData.append('status', 1);
            formData.append('order_by_name', 1);
            if (this.word) {
                formData.append('word', this.word);
            }
            if (this.gender) {
                formData.append('gender', this.gender.id);
            }

            // 1. احضر كل الطلاب
            axios.defaults.headers.common["per_page"] = 100000;
            const resStudents = await axios.post('/all_reservations', formData);
            const allStudents = resStudents.data.data.data || resStudents.data.students || [];

            // 2. احضر الحضور
            if (!this.selectedMonth || !this.selectedMonth.id) {
                this.selectedMonth = {
                    id: new Date().getMonth() + 1, // الشهر الحالي (1-12)
                    name: new Date().toLocaleString('default', { month: 'long' }) // اسم الشهر الحالي
                };
            }
            const resAttendance = await axios.get(`/attendance-by-month/${this.selectedMonth.id}`);
            this.loading = false;
            const attendanceList = resAttendance.data.data || [];

            // 3. جهز قائمة كل أيام الشهر الحالي
            const today = new Date();
            const year = today.getFullYear();
            const month = this.selectedMonth.id - 1; // تحويل الشهر من 1-12 إلى 0-11
            // this.selectedMonth.name = today.toLocaleString('default', { month: 'long', year: year });
            this.days = this.getDaysOfMonth(year, month);

            // 4. دمج بيانات الحضور مع الطلاب
            this.students = allStudents.map(student => {
                // ابحث عن حضور الطالب
                const found = attendanceList.find(a => a.user_id === student.id || a.user_id === student.user_id);
                return {
                    user_id: student.id || student.user_id,
                    name: student.name,
                    phone: student.phone,
                    gender: student.gender,
                    attendanceDates: found ? found.dates : []
                };
            });
        },
        async handleAttendanceQR({ studentId }) {
            const userId = parseInt(studentId);
            if (!userId) return;

            const now = new Date();
            const timeStr = now.toTimeString().slice(0, 8); // HH:mm:ss
            const today = now.toLocaleDateString('ar-EG', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' });

            try {
                const res = await axios.post('/attendance/qr', { user_id: userId });
                const toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 4500,
                    timerProgressBar: true,
                });

                if (res.data.status === 'already_exists') {
                    toast.fire({
                        icon: 'warning',
                        title: 'تم تسجيل الحضور مسبقاً',
                        html: `<strong>${res.data.student_name}</strong>`,
                    });
                } else {
                    toast.fire({
                        icon: 'success',
                        title: 'تم تسجيل حضور الطالب',
                        html: `<strong>${res.data.student_name}</strong><br>التاريخ: ${today}<br>الوقت: ${timeStr}`,
                    });
                    this.fetchAttendance();
                }
            } catch {
                Swal.fire({ icon: 'error', title: 'خطأ', text: 'تعذّر تسجيل الحضور', timer: 2500, showConfirmButton: false });
            }
        },

        async toggleAttendance(user_id, date, checked) {
          this.loading = true;
          // console.log(this.loading, "loading")
          // ابحث عن الطالب من قائمة الطلاب
          const student = this.students.find(s => s.user_id === user_id);
            // توليد نص الرسالة المنسقة
            this.attendance_message = `أ.طارق عبد الباري مدرس الرياضيات \nيحيط علم سيادتكم أنه قد تغيب ${student ? (student.gender == 1 ? 'أبنكم' : 'أبنتكم')  : ''} (${student ? student.name : ''}) يوم ${this.getDayName(date)} الموافق ${this.formatDayMonth(date)}`;
            await axios.post('/attendance', {
                user_id,
                date
            }).then((response) => {
                this.attendance_id = response.data.attendance.id;
                this.parent_phone = response.data.parent_phone;
            })
            .catch((error) => {
                console.error("Error toggling attendance:", error);
            });

            if (student.attendanceDates.includes(date)) {
              // Student already has absence for this day, do nothing
              this.fetchAttendance();
              return;
            }
            this.visible = true; // Show dialog on attendance toggle
            this.fetchAttendance();
            // this.loading = false;
        },
        async SendAttendanceMessage() {
            const phone = '2' + this.parent_phone;

            // ── 1. فحص WhatsApp ──
            let hasWhatsApp = false;
            try {
                const checkRes = await axios.post('/whatsapp/check', { phone });
                hasWhatsApp = checkRes.data.has_whatsapp === true;
            } catch {
                hasWhatsApp = false;
            }

            // ── 2. محاولة إرسال WhatsApp ──
            if (hasWhatsApp) {
                try {
                    const sendRes = await axios.post('/whatsapp/send', {
                        phone,
                        message: this.attendance_message,
                    });
                    if (sendRes.data.success) {
                        Swal.fire({
                            icon: 'success',
                            title: 'تم الإرسال',
                            text: 'تم إرسال الرسالة عبر واتساب بنجاح',
                            timer: 1500,
                            showConfirmButton: false
                        });
                        this.visible = false;
                        return;
                    }
                    // فشل WhatsApp → يُكمل إلى SMS
                } catch {
                    // استثناء → يُكمل إلى SMS
                }
            }

            // ── 3. SMS الحالي (كود SMS بدون أي تعديل) ──
            const formData = new FormData();
            formData.append('SenderName', "SMS invite");
            formData.append('RequestID', this.attendance_id);
            formData.append('PhoneNumber', phone);
            formData.append('Message', this.attendance_message);

            await axios
                .post(`https://hubapi.advansystelecom.com/api/bulkSMS/ForwardSMS`,
                    formData,
                    {
                      headers: {
                        'Authorization': '667d0a1e-f2b3-4bd5-8569-360b6e7b80b0',
                        'Content-Type': 'application/json'
                      }
                    }
                )
                .then((response) => {
                    const result = response.data;
                    if (result === "1") {
                        Swal.fire({
                            icon: 'success',
                            title: 'تم الإرسال',
                            text: 'تم إرسال الرسالة بنجاح',
                            timer: 1500,
                            showConfirmButton: false
                        });
                        this.visible = false;
                    }
                })
                .catch((error) => {
                    const result = error.response?.data?.Message;
                    const messages = {
                        '-1': 'رمز التوثيق غير صحيح',
                        '-2': 'رقم الجوال فارغ',
                        '-3': 'نص الرسالة فارغ',
                        '-4': 'اسم المرسل غير صحيح',
                        '-5': 'لا يوجد رصيد كافٍ',
                    };
                    Swal.fire({
                        icon: 'error',
                        title: 'خطأ',
                        text: messages[result] ?? 'حدث خطأ غير متوقع',
                        timer: 3000,
                        showConfirmButton: false
                    });
                });
        }
    },
    async mounted() {
        if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
        if (!this.gradeStore.allGrades.length) await this.gradeStore.fetchAllGrades();
        this.fetchAttendance();
    }
};
</script>